module.exports = __webpack_public_path__ + "static/media/logo.c27d62a7.png";